var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenFilledTickMarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5799 42.6813C18.7574 42.7129 15.9567 42.1842 13.3399 41.1259C10.7232 40.0676 8.34236 38.5008 6.33531 36.516C4.32827 34.5313 2.73488 32.1681 1.64741 29.5634C0.559945 26.9586 0 24.164 0 21.3413C0 18.5187 0.559945 15.7241 1.64741 13.1193C2.73488 10.5145 4.32827 8.15136 6.33531 6.16662C8.34236 4.18189 10.7232 2.61502 13.3399 1.55674C15.9567 0.498453 18.7574 -0.0302184 21.5799 0.00133344C27.1983 0.0641402 32.5653 2.34011 36.516 6.33531C40.4668 10.3305 42.6827 15.7226 42.6827 21.3413C42.6827 26.9601 40.4668 32.3522 36.516 36.3474C32.5653 40.3426 27.1983 42.6185 21.5799 42.6813ZM18.4439 26.428L12.8759 21.5533L10.2412 24.5667L18.8946 32.1347L33.5399 14.5613L30.4652 12.0013L18.4439 26.428Z",
    fill: "#14B872"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFilledTickMarkIcon);
export default __webpack_public_path__ + "static/media/GreenFilledTickMarkIcon.ba6b04511907c942ad0fa207c59d328b.svg";
export { ForwardRef as ReactComponent };